import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import type { ReactNode } from 'react'
import type { FallbackProps } from 'react-error-boundary'

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <div className="mx-auto mt-10 max-w-xl rounded-xl border border-red-200 bg-red-50 p-6 text-red-800">
    <h2 className="mb-2 text-lg font-semibold">Something went wrong</h2>
    <p className="mb-4 text-sm">{error instanceof Error ? error.message : 'Something went wrong'}</p>
    <button
      className="rounded-md bg-red-600 px-4 py-2 text-white hover:bg-red-700"
      onClick={resetErrorBoundary}
      type="button"
    >
      Try again
    </button>
  </div>
)

export const ErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ReactErrorBoundary FallbackComponent={ErrorFallback}>{children}</ReactErrorBoundary>
)
